import { NgModule } from '@angular/core';
import { IonicPerfectIapComponent } from './ionic-perfect-iap.component';

@NgModule({
  declarations: [
    IonicPerfectIapComponent
  ],
  imports: [
  ],
  exports: [
    IonicPerfectIapComponent
  ]
})
export class IonicPerfectIapModule { }
